import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  browserInfo: {
    ipAddress: null,
    location: null,
    browser: null,
    operatingSystem: null,
    deviceType: null,
    screenResolution: null,
    isLoading: true,
    error: null,
  },
  isUserInfoLoaded: false,
};

const userInfoSlice = createSlice({
  name: 'userInfo',
  initialState,
  reducers: {
    setUserBrowserInfo: (state, action) => {
      state.browserInfo = action.payload;
      state.isUserInfoLoaded = true;
    },
    clearUserBrowserInfo: (state) => {
      state.browserInfo = initialState.browserInfo;
      state.isUserInfoLoaded = false;
    },
    updateUserInfoLoading: (state, action) => {
      state.browserInfo.isLoading = action.payload;
    },
  },
});

export const { 
  setUserBrowserInfo, 
  clearUserBrowserInfo, 
  updateUserInfoLoading 
} = userInfoSlice.actions;

export default userInfoSlice.reducer;
